module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/809d6cb7f9b548ad3f360a4d72a93167.png";